import React from 'react'
import { ScreeningQuestionAnswer } from 'types/campaign/applications'

const ScreeningQuestionAnswers: React.FC<{ answers: ScreeningQuestionAnswer[] }> = ({ answers }) => {
    return (
        <div className='detail-card border-1'>
            <div className="detail-card-header d-flex justify-content-between align-items-center">
                Screening Question Answers
            </div>
            <div className="detail-card-body p-3">
                <ul className="list-group">
                    {answers.map((answer) => (
                        <li className="list-group-item" key={answer.question}>
                            <div className="d-flex flex-column">
                                <span className="fw-bold"> Q. {answer.question}</span>
                                <span className="">A. {typeof (answer.answer) === 'boolean' ? answer.answer ? 'Yes' : 'No' : answer.answer}</span>
                            </div>
                        </li>
                    ))}
                </ul>

            </div>
        </div>
    )
}

export default ScreeningQuestionAnswers